import TaskRunner from '../base/TaskRunner';
import noUiSlider from 'nouislider';
window.noUiSlider = noUiSlider

TaskRunner.add(() => {
    if (window.noUiSlider) {
        document.querySelectorAll('.nouislider').forEach(sldRoot => {
            const settings = {
                start: [Number(sldRoot.getAttribute('data-start'))],
                step: Number(sldRoot.getAttribute('data-step')) || 1,
                connect: [true, false],
                range: {
                    min: [Number(sldRoot.getAttribute('data-from'))],
                    max: [Number(sldRoot.getAttribute('data-to'))]
                }
            };
            let points = sldRoot.getAttribute('data-points').split(',');
            points.unshift(settings.range.min);
            points.push(settings.range.max);

            const unit = sldRoot.getAttribute('data-unit') || '';
            const pointsContainer = sldRoot.querySelector('.nouislider--points');
            const pointsContainerRange = settings.range.max - settings.range.min;

            points.forEach(point => {
                if (point.length > 0) {
                    const pointElement = document.createElement('span');
                    pointElement.innerText = Number(point).toLocaleString() + unit;

                    pointElement.style.left = `${(Number(point) - settings.range.min) / pointsContainerRange * 100}%`;
                    pointsContainer.appendChild(pointElement);
                }
            });

            const sliderContainer = sldRoot.querySelector('.nouislider--slider');
            noUiSlider.create(sliderContainer, settings);

            const sliderValue = sldRoot.querySelector('.nouislider--value > span:first-child');
            sliderValue.innerText = Number(sliderContainer.noUiSlider.get());

            sliderContainer.noUiSlider.on('update', (vals, handle) => {
                sliderValue.innerText = Number(vals[handle]).toLocaleString();
            });
        });
    }
});